import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import { getAppConfigs, updateAppConfigs } from "../../helpers/backend_helper";
import {
  GET_APP_CONFIGS,
  GetAppConfigsAction,
  UPDATE_APP_CONFIGS,
  UpdateAppConfigsAction,
} from "./actionTypes";
import {
  getAppConfigsError,
  getAppConfigsSuccess,
  updateAppConfigsError,
  updateAppConfigsSuccess,
} from "./actions";

function* getAppConfigsSaga({ payload: {} }: GetAppConfigsAction) {
  try {
    const response: ResponseGenerator = yield call(getAppConfigs);
    yield put(getAppConfigsSuccess(response.data));
  } catch (error) {
    yield put(getAppConfigsError(error));
  }
}

function* updateAppConfigsSaga({
  payload: { request },
}: UpdateAppConfigsAction) {
  try {
    const response: ResponseGenerator = yield call(updateAppConfigs, request);
    yield put(updateAppConfigsSuccess(response.data));
  } catch (error) {
    yield put(updateAppConfigsError(error));
  }
}

function* AppConfigsSaga() {
  yield takeEvery(GET_APP_CONFIGS, getAppConfigsSaga);
  yield takeEvery(UPDATE_APP_CONFIGS, updateAppConfigsSaga);
}

export default AppConfigsSaga;
